import React, { useContext, useEffect, useState } from "react";
import { Alert } from 'react-bootstrap';
import { useParams, useLocation } from "react-router-dom";

import { Context } from "../providers/mainProvider";
import Layout from "../layout/layout";
import { GetDashboardEmbedData } from "../services/get_dashboard_instance_embed_token";

export default function DisplayDashboardInstance() {

    const [errorMessage, setErrorMessage] = useState("");
    const { setValue, user_role, companyid, updateBreadcrumb } = useContext(Context);
    const { instance_id } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const company_id = user_role === 'superuser' ? searchParams.get('company_id') : companyid;

    const embedPowerBIReport = (report_id, embed_token, mobile_number, username) => {
        const models = window['powerbi-client'].models;
        console.log("embed_token", embed_token);
        console.log("report_id", report_id);
        console.log("mobile_number", mobile_number);
        console.log("username", username);
        const filter = {
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
                table: "Final_Blitz Summary",
                column: "Company ID"
            },
            operator: "In",
            values: [parseInt(company_id)]
        };

        const config = {
            type: 'report',
            id: report_id,
            embedUrl: 'https://app.powerbi.com/reportEmbed',
            accessToken: embed_token,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.All,
            filters: [filter],
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true,
            },
        };

        const embedContainer = document.getElementById('embedContainer');
        const report = window.powerbi.load(embedContainer, config);
 
        report.on('loaded', async () => {
            try {
                const pages = await report.getPages();
                const pageMap = {};
                pages.forEach(p => pageMap[p.displayName?.trim()] = p);
                
                const userProfilePage = pages.find(p =>
                    p.displayName.includes("User Profile")
                );
                const userNamePage = pages.find(p =>
                    p.displayName.includes("User Name")
                );
                const summaryPage = pages.find(p =>
                    p.displayName.includes("Arcadis Summary")
                );

                const activePage = pages.find(p => p.isActive);

                if (!userProfilePage) return console.warn("User Profile page not found.");
                if (!userNamePage) return console.warn("User Name page not found.");

                if (userProfilePage) {
                    await userProfilePage.setActive();
                    const visuals = await userProfilePage.getVisuals();

                    for (const visual of visuals) {
                        if (visual.type !== "slicer") continue;
                        const title = visual.title?.toLowerCase?.() || "";
                        if (!title.includes("mobile")) continue;

                        const slicerState = await visual.getSlicerState();
                        const target = slicerState?.targets?.[0];

                        if (
                            target?.column === "Mobile Number" &&
                            target?.table === "Final_Blitz Summary"
                        ) {
                            const newState = {
                                filters: [
                                    {
                                        $schema: "http://powerbi.com/product/schema#basic",
                                        target,
                                        operator: "In",
                                        values: [mobile_number],
                                    }
                                ]
                            };
                            await visual.setSlicerState(newState);
                            break;
                        }
                    }
                }

                if (userNamePage) {
                    await userNamePage.setActive();
                    const visuals = await userNamePage.getVisuals();

                    for (const visual of visuals) {
                        if (visual.type !== "slicer") continue;
                        const title = visual.title?.toLowerCase?.() || "";
                        if (!title.includes("username")) continue;

                        const slicerState = await visual.getSlicerState();
                        const target = slicerState?.targets?.[0];

                        if (
                            target?.column === "User Name" &&
                            target?.table === "Final_Blitz Summary"
                        ) {
                            const newState = {
                                filters: [
                                    {
                                        $schema: "http://powerbi.com/product/schema#basic",
                                        target,
                                        operator: "In",
                                        values: [username],
                                    }
                                ]
                            };
                            await visual.setSlicerState(newState);
                            break;
                        }
                    }
                }
                await report.render();
                if (activePage) {
                    setTimeout(async () => {
                        try {
                            await activePage.setActive();
                        } catch (e) {
                            console.error("Error switching to summary page:", e);
                        }
                    }, 500);
                }
            } catch (err) {
                console.error("Error during embedding or slicer filtering:", err);
            }
        });
    };

    useEffect(() => {
        setValue({ loading: true });
        // setValue({ breadcrumb_value: "" });
        GetDashboardEmbedData(instance_id, company_id)
        .then((data) => {
            if (data.success === true){
                setValue({ loading: false });
                if (user_role != 'superuser'){
                    // updateBreadcrumb(data['data']['instance_name']);
                    const breadcrumb = {
                        name: data['data']['instance_name'],
                        link: window.location.pathname,
                    };
                    updateBreadcrumb(breadcrumb);
                }
                else{
                    const breadcrumb = {
                        name: 'Preview',
                        link: window.location.pathname,
                    };
                    updateBreadcrumb(breadcrumb);
                }
                setTimeout(() => {
                    embedPowerBIReport(data['data']['report_id'], data['data']['embed_token'], data['data']['mobile_number'], data['data']['username']);
                }, 3000);
            }
            else{
                setValue({ loading: false });
                setErrorMessage(<Alert variant="danger">{data.message}</Alert>)
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            setValue({ loading: false });
            setErrorMessage(<Alert variant="danger">{error.message}</Alert>)
        })
    }, []);

    return (
        <Layout activeMenuItem={user_role === "superuser" ? "organizations" : "myDashboards"}>
            <div className="dashboard-content">
                {errorMessage}
                <div id="embedContainer" style={{ height: '660px' }}></div>
            </div>
        </Layout>
    );

}